/**API-URLS */

export const YOUTUBE_SEARCH_API_URL =
  "https://www.googleapis.com/youtube/v3/search";
